import { FaqService } from "@vahak/core/dist/_services/faq.service";
import { useDefaultTopLayout } from "components/layout/layout-methods";

export const getFullTruckBookingPageLayout = useDefaultTopLayout;

export const getFullTruckBookingStaticProps = async () => {
    const { faqs } = await FaqService.getFaqsByCateg({
        categSlug: "booking-loads"
    });

    return { faqs };
};
